import { render, staticRenderFns } from "./ChatroomAddForm.vue?vue&type=template&id=3f309bcf&scoped=true&"
import script from "./ChatroomAddForm.vue?vue&type=script&lang=js&"
export * from "./ChatroomAddForm.vue?vue&type=script&lang=js&"
import style0 from "./ChatroomAddForm.vue?vue&type=style&index=0&id=3f309bcf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f309bcf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Ampps\\www\\strana\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f309bcf')) {
      api.createRecord('3f309bcf', component.options)
    } else {
      api.reload('3f309bcf', component.options)
    }
    module.hot.accept("./ChatroomAddForm.vue?vue&type=template&id=3f309bcf&scoped=true&", function () {
      api.rerender('3f309bcf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/resources/js/components/chatroom/ChatroomAddForm.vue"
export default component.exports